<template>
  <div
    class="ttabs-layout"
    ref="ttabs-layout"
    >
    <div class="ttabs-layout-header">
      <div
        class="ttabs-layout-header-tab"
        :style="
        tab.show?
        `width: calc(var(--ttabs_layout_${tab.identifier}_width) * 1px);
        background-color: rgb(41,41,41);
        `
        :
        'width: 150px; flex-shrink: 0'

        "
        v-for="(tab, tab_index) in tabs"
        :key="tab.name"
        @click="$emit('tabClicked', tab_index), sizeTabs(false)"
        >
        <TText :value="tab.name"/>
      </div>
    </div>
    <div class="ttabs-layout-body">
      <template v-for="(tab, tab_index) in showTabs">
        <div
          :key="tab.identifier"
          class="ttabs-layout-body-tab"
          :style="`
            width: calc(var(--ttabs_layout_${tab.identifier}_width) * 1px);`">
          <div class="ttabs-layout-body-tab-activator">
            <ActivatorSlider
              v-if="tab_index !== showTabs.length-1"
              class="self-centered cursor-col-resize"
              :css_variable="`--ttabs_layout_${tab.identifier}_width`"
              :css_variable_negative="`--ttabs_layout_${showTabs[tab_index+1].identifier}_width`"
              @resize="contentResized(tab.identifier, showTabs[tab_index+1].identifier)"
            />
          </div>
          <div
            :id="`ttabs-${tab.identifier}-content`"
            class="ttabs-layout-body-tab-content"
            :style="`${tab.color_body?`background-color: ${tab.color_body};`:''}`"
            >
            <slot :name="tab.identifier"/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import ActivatorSlider from '@/components/ProjectTaktPlan/ActivatorSlider.component.vue';
  import TText from '@/components/Taktify/TText.component.vue'
  export default {
    props: ['tabs'],
    components: {
      ActivatorSlider,
      TText
    },
    data: () => ({
    }),
    mounted() {
      window.addEventListener('resize', this.sizeTabs);
      this.sizeTabs(true)
    },
    beforeDestroy() {
    window.removeEventListener('resize', this.sizeTabs);
    },
    computed: {
      showTabs() {
        return this.tabs.filter(tab => tab.show);
      }
    },
    methods: {
      sizeTabs(initial) {
        let sum = 0;
        if (initial) {
          this.tabs.forEach(tab => {
            if (tab.show) {
              sum = sum + tab.initial_width_factor
            }
          });
        } else {
          this.tabs.forEach(tab => {
            if (tab.show) {
              sum = sum + parseInt(getComputedStyle(document.body).getPropertyValue(`--ttabs_layout_${tab.identifier}_width`));
            }
          });
        }
        this.tabs.forEach(tab => {
          let width = 0;
          if (initial && sum !== 0) {
            width = this.$refs['ttabs-layout'].clientWidth * (tab.initial_width_factor / sum);
          } else if (sum !== 0) {
            width = this.$refs['ttabs-layout'].clientWidth * (parseInt(getComputedStyle(document.body).getPropertyValue(`--ttabs_layout_${tab.identifier}_width`)) / sum);
          }
          document.body.style.setProperty(`--ttabs_layout_${tab.identifier}_width`, width);
        })
      },
      contentResized(tab, next_tab) {
        if (tab === 'buildingmodel' || next_tab === 'buildingmodel') {
          let el = document.getElementById('ttabs-buildingmodel-content');
          el.dispatchEvent(new Event('resizetabs'));
        }
      }
    }
  }
</script>
<style>
  .ttabs-layout {
    padding: 2px;
  }
  .ttabs-layout {
    width: 100%;
    height: 36px;
  }
  .ttabs-layout-header {
    display: flex;
    width: 100%;

  }
  .ttabs-layout-header-tab {
    justify-content: center;
    text-align: center;
    border-right: 1px black solid;
    user-select: none;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
  }
  .ttabs-layout-body {
    /* height: calc(100% - 90px); */
    height: calc(100% - 24px);
    width: 100%;
    display: flex;
  }
  .ttabs-layout-body-tab {
    position: relative;
    height: 100%;
    flex-shrink: 0;
    padding: 2px 1px 2px 1px;
  }
  .ttabs-layout-body-tab-content {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    /* background-color: rgb(41,41,41); */
  }
  .ttabs-layout-body-tab-activator {
    position: absolute;
    right: 0px;
    top: 50%;
  }
</style>
